import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-currency-range',
  templateUrl: './currency-range.component.html',
  standalone: false
})
export class CurrencyRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
